module.exports = __webpack_public_path__ + "img/shipo-icon-arrow-forward.d7756130.svg";